import actions from "./actions";
import { DataService } from "../../config/data/dataService";
const {
  categoryDataBegin,
  categoryDataSuccess,
  categoryDataErr,
  brandDataBegin,
  brandDataSuccess,
  brandDataErr,
  storeListDataBegin,
  storeListDataSuccess,
  storeListDataErr,
  storePincodeDataBegin,
  storePincodeDataSuccess,
  storePincodeDataErr,
  storePincodeDataReset,
  modelListDataBegin,
  modelListDataSuccess,
  modelListDataErr,
  stockEmployeeListDateBegin,
  stockEmployeeListDataSuccess,
  stockEmployeeListDataErr,
  maintenanceEmployeeListDateBegin,
  maintenanceEmployeeListDateSuccess,
  maintenanceEmployeeListDateErr,
  vendorEmployeeListDataBegin,
  vendorEmployeeListDataSuccess,
  vendorEmployeeListDataErr,
  stateListDataBegin,
  stateListDataSuccess,
  stateListDataErr,
  languageListDataBegin,
  languageListDataSuccess,
  languageListDataErr,
  getProductTypeBegin,
  getProductTypeSuccess,
  getProductTypeErr,
  getBrandBegin,
  getBrandSuccess,
  getBrandErr,
  getModelBegin,
  getModelSuccess,
  getModelErr,
  getEmployeeDetailBegin,
  getEmployeeDetailSuccess,
  getEmployeeDetailErr,
  getEmployeeDetailDataReset,
  getExchangeModelBegin,
  getExchangeModelSuccess,
  getExchangeModelErr,
  getApexTradeModelListBegin,
  getApexTradeModelListSuccess,
  getApexTradeModelListErr,
  getTradeModelListBegin,
  getTradeModelListSuccess,
  getTradeModelListErr,
} = actions;

const getCategoryList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(categoryDataBegin());
      const response = await DataService.get("/getCategoryList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(categoryDataSuccess(response.data.data));
      } else {
        dispatch(categoryDataErr());
      }
    } catch (err) {
      dispatch(categoryDataErr(err));
    }
  };
};

const getNewCategoryList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(categoryDataBegin());
      const response = await DataService.get("/getNewCategoryList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(categoryDataSuccess(response.data.data));
      } else {
        dispatch(categoryDataErr());
      }
    } catch (err) {
      dispatch(categoryDataErr(err));
    }
  };
};

const getBrandList = () => {
  return async (dispatch) => {
    try {
      dispatch(brandDataBegin());
      const response = await DataService.get("/getBrands");
      if (response.status === 200 && response.data.status === true) {
        dispatch(brandDataSuccess(response.data.data));
      } else {
        dispatch(brandDataErr());
      }
    } catch (err) {
      dispatch(brandDataErr(err));
    }
  };
};

const getBranchList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(storeListDataBegin());
      const response = await DataService.get("/getBranchList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(storeListDataSuccess(response.data.data));
      } else {
        dispatch(storeListDataErr());
      }
    } catch (err) {
      dispatch(storeListDataErr(err));
    }
  };
};

const getStorePincode = (data) => {
  return async (dispatch) => {
    try {
      dispatch(storePincodeDataBegin());
      const response = await DataService.post("/getStoreListBasedonPincode", {
        pincode: data,
      });
      if (response.status === 200 && response.data.status === true) {
        dispatch(storePincodeDataSuccess(response.data.data));
      } else {
        dispatch(storePincodeDataErr());
      }
    } catch (err) {
      dispatch(storePincodeDataErr(err));
    }
  };
};

const resetStorePincode = () => {
  return async (dispatch) => {
    dispatch(storePincodeDataReset());
  };
};

const getModelDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(modelListDataBegin());
      const response = await DataService.post(
        "/getModelListBasedonCategoryBrand",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(modelListDataSuccess(response.data.data));
      } else {
        dispatch(modelListDataErr());
      }
    } catch (err) {
      dispatch(modelListDataErr(err));
    }
  };
};

const getNewModelDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(modelListDataBegin());
      const response = await DataService.post(
        "/getNewModelListBasedonCategoryBrand",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(modelListDataSuccess(response.data.data));
      } else {
        dispatch(modelListDataErr());
      }
    } catch (err) {
      dispatch(modelListDataErr(err));
    }
  };
};

const getStockEmployeeList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(stockEmployeeListDateBegin());
      const response = await DataService.post("/getStockEmployeeList", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(stockEmployeeListDataSuccess(response.data.data));
      } else {
        dispatch(stockEmployeeListDataErr());
      }
    } catch (err) {
      dispatch(stockEmployeeListDataErr(err));
    }
  };
};

const getMaintenanceEmployeeList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(maintenanceEmployeeListDateBegin());
      const response = await DataService.post(
        "/getMaintenanceEmployeeList",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(maintenanceEmployeeListDateSuccess(response.data.data));
      } else {
        dispatch(maintenanceEmployeeListDateErr());
      }
    } catch (err) {
      dispatch(maintenanceEmployeeListDateErr(err));
    }
  };
};

const getVendorEmployeeList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(vendorEmployeeListDataBegin());
      const response = await DataService.post("/getVendorEmployeeList", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(vendorEmployeeListDataSuccess(response.data.data));
      } else {
        dispatch(vendorEmployeeListDataErr());
      }
    } catch (err) {
      dispatch(vendorEmployeeListDataErr(err));
    }
  };
};

const getStateList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(stateListDataBegin());
      const response = await DataService.post("/getStateList", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(stateListDataSuccess(response.data.data));
      } else {
        dispatch(stateListDataErr());
      }
    } catch (err) {
      dispatch(stateListDataErr(err));
    }
  };
};

const getLanguageList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(languageListDataBegin());
      const response = await DataService.post("/getLanguageList", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(languageListDataSuccess(response.data.data));
      } else {
        dispatch(languageListDataErr());
      }
    } catch (err) {
      dispatch(languageListDataErr(err));
    }
  };
};

export const getProductType = (data) => {
  return async (dispatch) => {
    try {
      const payload = {};
      if (data) payload.type = data;
      dispatch(getProductTypeBegin());
      const response = await DataService.post("/getProducts", payload);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getProductTypeSuccess(response.data.data));
      } else {
        dispatch(getProductTypeErr());
      }
    } catch (error) {
      dispatch(getProductTypeErr(error));
    }
  };
};

export const getBrand = () => {
  return async (dispatch) => {
    try {
      dispatch(getBrandBegin());
      const response = await DataService.get("/getBrands");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getBrandSuccess(response.data.data));
      } else {
        dispatch(getBrandErr());
      }
    } catch (error) {
      dispatch(getBrandErr(error));
    }
  };
};

export const getModel = (data) => {
  return async (dispatch) => {
    try {
      let payload = {};
      if (data) payload = { ...data };
      dispatch(getModelBegin());
      const response = await DataService.post("/getModel", payload);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getModelSuccess(response.data.data));
      } else {
        dispatch(getModelErr());
      }
    } catch (error) {
      dispatch(getModelErr(error));
    }
  };
};

export const getEmployeeDetail = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getEmployeeDetailBegin());
      const response = await DataService.post("/getEmployeeDetail", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getEmployeeDetailSuccess(response.data.data));
      } else {
        dispatch(getEmployeeDetailErr(response.data.message));
      }
    } catch (error) {
      dispatch(getEmployeeDetailErr(error));
    }
  };
};

export const getEmployeeDetailReset = () => {
  return async (dispatch) => {
    dispatch(getEmployeeDetailDataReset());
  };
};

export const getExchangeModelDetail = () => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeModelBegin());
      const response = await DataService.get("/getExchangeModel");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeModelSuccess(response.data.data));
      } else {
        dispatch(getExchangeModelErr(response.data.message));
      }
    } catch (error) {
      dispatch(getExchangeModelErr(error));
    }
  };
};

export const apexTradeModelList = () => {
  return async (dispatch) => {
    try {
      dispatch(getApexTradeModelListBegin());
      const response = await DataService.get("/getApexTradeModelList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getApexTradeModelListSuccess(response.data.data));
      } else {
        dispatch(getApexTradeModelListErr(response.data.message));
      }
    } catch (error) {
      dispatch(getApexTradeModelListErr(error));
    }
  };
};

export const tradeModelList = () => {
  return async (dispatch) => {
    try {
      dispatch(getTradeModelListBegin());
      const response = await DataService.get("/getTradeModelList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getTradeModelListSuccess(response.data.data));
      } else {
        dispatch(getTradeModelListErr(response.data.message));
      }
    } catch (error) {
      dispatch(getTradeModelListErr(error));
    }
  };
};

export {
  getCategoryList,
  getNewCategoryList,
  getBrandList,
  getBranchList,
  getStorePincode,
  resetStorePincode,
  getModelDetails,
  getNewModelDetails,
  getStockEmployeeList,
  getMaintenanceEmployeeList,
  getVendorEmployeeList,
  getStateList,
  getLanguageList,
};
